// extracted by mini-css-extract-plugin
export default {"navigationPath":"NavigationPath_navigationPath__q50m6","navigationLink":"NavigationPath_navigationLink__RGBZz","navigationLinkText":"NavigationPath_navigationLinkText__6pTCd"};